import React, { FC, useState, useEffect } from 'react'
import { getSurvey } from '../survey/list/core/_requests'
import { getStudentSemesterCourse } from '../studentsemestercourse/list/core/_requests'
import { getSurveyApplication } from '../surveyapplication/list/core/_requests'
import { getCourseOutcome } from '../courseoutcome/list/core/_requests'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SurveyResultsComponent from '../../modules/surveyanalytics/surveyanalytics'
import SurveyTableComponent from '../../modules/surveyanalytics/surveyanalyticstable'
import SurveyGaugeChart from '../../modules/surveyanalytics/SurveyGaugeChart'
import MatrixQuestionChartSwitcher from '../../modules/surveyanalytics/MatrixQuestionChartSwitcher'

// Yükleme göstergesi için bir CSS sınıfı ekleyin
const spinnerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '2rem',
    color: '#555',
};

const SurveyResultGeneral = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const state: any = location.state

    const [surveyResults, setSurveyResults] = React.useState<any[]>([])
    const [survey, setSurvey] = React.useState<any>('')
    const [finished, setFinished] = React.useState(0)
    const [showMatrixCharts, setShowMatrixCharts] = useState(false)

    useEffect(() => {
        if (state) {
            getSurvey(`filter_GuidString=${state}`, 'Id,Guid,SurveyJson,SurveyApplication*Name', 'SurveyApplication').then((surveyResponse: any) => {
                const rawSurvey = surveyResponse?.data?.[0]?.surveyJson
                let parsedSurvey: any = ''

                try {
                    parsedSurvey = rawSurvey ? JSON.parse(rawSurvey) : ''
                } catch (error) {
                    parsedSurvey = ''
                    console.error('Anket şablonu çözümlenemedi:', error)
                }

                const applicationArray = Array.isArray(surveyResponse?.data?.[0]?.surveyApplicationName)
                    ? surveyResponse.data[0].surveyApplicationName
                    : []

                const sanitizedResults = applicationArray
                    .filter((entry: any) => typeof entry === 'string' && entry.length > 0)
                    .map((entry: string) => {
                        try {
                            return JSON.parse(entry)
                        } catch (error) {
                            console.error('Anket sonucu çözümlenemedi:', error)
                            return null
                        }
                    })
                    .filter((entry: any) => {
                        if (!entry || typeof entry !== 'object') {
                            return false
                        }

                        return Object.values(entry).some((value: any) => {
                            if (typeof value === 'string') {
                                return value.trim().length > 0
                            }

                            if (Array.isArray(value)) {
                                return value.length > 0
                            }

                            if (value && typeof value === 'object') {
                                return Object.keys(value).length > 0
                            }

                            return false
                        })
                    })

                setSurvey(parsedSurvey)
                setSurveyResults(sanitizedResults)
            })
            //console.log(state)
        }
    }, [state])

    useEffect(() => {
        //console.log(surveyResults)
        //console.log(survey)
        if (surveyResults.length > 0 && survey !== '') {
            setFinished(1)
        }
    }, [surveyResults, survey])

    return (
        <>
            {finished === 0 && (
                <div style={spinnerStyle}>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </div>
            )}
            {finished === 1 && surveyResults && (
                <>
                    <div className='d-flex justify-content-end mb-5'>
                        <button
                            className='btn btn-sm btn-light-primary'
                            onClick={() => setShowMatrixCharts((prev) => !prev)}
                        >
                            {showMatrixCharts ? 'SurveyJS Grafiklerini Göster' : 'Pasta / Bar Grafiklerini Göster'}
                        </button>
                    </div>
                    <SurveyGaugeChart surveyJson={survey} data={surveyResults} />
                    {showMatrixCharts && (
                        <MatrixQuestionChartSwitcher surveyJson={survey} surveyData={surveyResults} />
                    )}
                    <SurveyResultsComponent surveyJson={survey} surveyData={surveyResults} />
                    <SurveyTableComponent surveyJson={survey} surveyData={surveyResults} />
                </>
            )}

        </>
    )
}

export default SurveyResultGeneral
